import type { FC } from "react";

import type { CheckoutConfigurationCartOverviewTier } from "@jti/commerce";

import { CartOverviewTier } from "@checkout/components/CartOverviewTier";
import { CartPoints } from "@checkout/components/CartPoints";
import { useLoyaltyStatus } from "@checkout/hooks/useLoyaltyStatus";

type CartOverviewContainerProps = {
  totalLoyaltyPoints: number;
  cartOverviewTier?: CheckoutConfigurationCartOverviewTier;
};

export const CartOverviewContainer: FC<CartOverviewContainerProps> = ({ totalLoyaltyPoints, cartOverviewTier }) => {
  const hasLoyaltyStatus = useLoyaltyStatus();
  const isLoyaltyRewardsNotReady = totalLoyaltyPoints <= 0 || !hasLoyaltyStatus;
  const shouldShowCartOverviewTier = Boolean(cartOverviewTier?.enabled) && !isLoyaltyRewardsNotReady;

  if (shouldShowCartOverviewTier && cartOverviewTier) {
    return <CartOverviewTier cartPoints={totalLoyaltyPoints} {...cartOverviewTier} />;
  }

  if (isLoyaltyRewardsNotReady) {
    return null;
  }

  return <CartPoints totalPointsCount={totalLoyaltyPoints} />;
};
